import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import VueLazyload from 'vue-lazyload'
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(ElementUI);
Vue.use(VueLazyload)
Vue.config.productionTip = false
import server from '@/service/server';
Vue.prototype.$server = server;
Vue.use(VueLazyload, {
  preLoad: 1.3,                 // 预载高度比例
  error: '',     // 加载失败图片
  loading: '',   // 加载中
  attempt: 1
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
